"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _dataGrid = _interopRequireDefault(require("../data-grid.js"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: 1.5rem !important;\n  margin-right: 1.5rem !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MarginWrapper = _styledComponents["default"].div(_templateObject());

var Navbar = function Navbar(_ref) {
  var filterOptions = _ref.filterOptions,
      tableRowData = _ref.tableRowData,
      tag = _ref.tag,
      exportUrl = _ref.exportUrl,
      disableNavbarSearch = _ref.disableNavbarSearch;
  return /*#__PURE__*/_react["default"].createElement(_dataGrid["default"].Navbar, null, filterOptions && /*#__PURE__*/_react["default"].createElement(MarginWrapper, null, /*#__PURE__*/_react["default"].createElement(_dataGrid["default"].Navbar.Filtering, {
    useTabs: filterOptions.useTabs,
    options: filterOptions.filters,
    dataSet: tableRowData,
    tag: tag
  })), /*#__PURE__*/_react["default"].createElement(_dataGrid["default"].Alignment, {
    rightAligned: true
  }, /*#__PURE__*/_react["default"].createElement(_dataGrid["default"].Navbar.Export, {
    exportUrl: exportUrl
  }), /*#__PURE__*/_react["default"].createElement(_dataGrid["default"].Navbar.ViewSwitch, null), !disableNavbarSearch && /*#__PURE__*/_react["default"].createElement(_dataGrid["default"].Navbar.Search, null)));
};

Navbar.propTypes = {
  filterOptions: _propTypes["default"].object,
  tableRowData: _propTypes["default"].array,
  tag: _propTypes["default"].string.isRequired,
  exportUrl: _propTypes["default"].string,
  disableNavbarSearch: _propTypes["default"].bool
};
var _default = Navbar;
exports["default"] = _default;